import { FC } from 'react';

export const CurrentTrendLegendMarker: FC = () => {
    return (
        <div className="size-3 bg-base-chart1"></div>
    )
}